export const validateAmount = (amount: string): number | string => {
    if (amount === '') {
        return amount;
    }
    return Number(amount.replace(/[^\d|]/ug, ''));
};
